import * as styles from "./SelectItem.css";

import { clsx } from "clsx";

import { Select as BaseSelect } from "@base-ui/react/select";
import { Icon } from "@frontend/components/atoms/Icon";

import { useSelectContext } from "./Select.context";
import type { SelectItemProps } from "./Select.types";
import { SELECT_EFFECT_ATTRIBUTE } from "./constants";

export function SelectItem({
  className,
  children,
  leftSection,
  ...props
}: SelectItemProps) {
  const { size, effect } = useSelectContext();

  return (
    <BaseSelect.Item
      data-slot="select-item"
      {...{ [SELECT_EFFECT_ATTRIBUTE]: effect }}
      className={clsx(styles.item({ size }), className)}
      {...props}
    >
      {leftSection ? (
        <span
          data-slot="select-item-left-section"
          className={styles.itemLeftSection}
        >
          {leftSection}
        </span>
      ) : null}

      <BaseSelect.ItemText className={styles.itemText}>
        {children}
      </BaseSelect.ItemText>

      <BaseSelect.ItemIndicator
        data-slot="select-item-indicator"
        className={styles.itemIndicator}
      >
        <Icon name="Check" />
      </BaseSelect.ItemIndicator>
    </BaseSelect.Item>
  );
}
